module.exports = __webpack_public_path__ + "img/PattisonLogo.b95e37cc.png";